import React from 'react';
import {
  Controller,
  FieldValues,
  RegisterOptions,
  useFormContext,
} from 'react-hook-form';
import { AppAutocomplete, AppAutocompleteProps } from './appAutocomplete';

interface AppControlledAutocompleteProps<T> extends AppAutocompleteProps<T> {
  name: string;
  shouldUnregister?: boolean;
  rules?: Omit<
    RegisterOptions<FieldValues, string>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
}

export function AppControlledAutocomplete<T>({
  name,
  isRequired = false,
  defaultValue = null,
  shouldUnregister = false,
  handleChange,
  rules,
  ...props
}: AppControlledAutocompleteProps<T>): JSX.Element {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: {
          value: isRequired,
          message: 'This field is required',
        },
        ...rules,
      }}
      defaultValue={defaultValue}
      shouldUnregister={shouldUnregister}
      render={({ field: { ref, ...field }, fieldState }) => (
        <AppAutocomplete
          {...field}
          {...props}
          mRef={ref}
          isRequired={isRequired}
          handleChange={(event, data) => {
            if (handleChange) {
              handleChange(event, data);
            }

            field.onChange(data);
          }}
          isError={!!fieldState.error || props.isError}
          errorMessage={fieldState.error?.message}
        />
      )}
    />
  );
}
